import { render, staticRenderFns } from "./QuestionTagEdit.vue?vue&type=template&id=03cb493a&"
import script from "./QuestionTagEdit.vue?vue&type=script&lang=js&"
export * from "./QuestionTagEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports